import { useChangeFilterValue, useFilterValue } from '@btime/react-contexts'
import React from 'react'

import StatusPicker from '../picker/StatusPicker'

const StatusFilter = ({ field, ...props }) => {
  field = field || 'statusIds'
  const label = 'Status'
  const value = useFilterValue(field, [])
  const handleChange = useChangeFilterValue()

  return (
    <div>
      <StatusPicker value={value} onChange={handleChange(field)} multiple label={label} {...props} />
    </div>
  )
}

export default StatusFilter
